/*
 * Funky Chair — sticky third-level menu (the M&L colour collections).
 *
 * THE PROBLEM THIS SOLVES
 * The colours are collapsed until you hover M&L Paints. On pure CSS :hover they
 * also collapse the instant the cursor leaves M&L — including when it leaves
 * heading DOWN towards Lighting & Lamps. The panel then shrinks by the height of
 * the colour list, its bottom edge jumps up above the cursor, the cursor is
 * suddenly outside the menu, and the whole dropdown shuts. You cannot walk down
 * past a section that vanishes as you walk through it.
 *
 * THE FIX
 * Once a section is opened, keep it open until the cursor leaves the dropdown
 * entirely. Nothing moves while you travel down the panel, so you land on the
 * item you were aiming at. CSS can't do this — it has no memory of "was opened".
 *
 * Delegated from document because Horizon re-renders the header through the
 * Section Rendering API, which would silently drop listeners bound to the menu.
 */
(function () {
  const OPEN = 'fc-sub-open';

  // Tell the stylesheet the script is alive. The collapse is gated on this, so if
  // this file ever fails to load the colours render inline (long but stable)
  // rather than collapsing on :hover and shutting the menu under the cursor.
  document.documentElement.classList.add('fc-js');

  const closeAll = () => {
    for (const el of document.querySelectorAll('.' + OPEN)) el.classList.remove(OPEN);
  };

  document.addEventListener('mouseover', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    // Outside any dropdown panel — the menu is closing (or already shut). Reset,
    // so the colours start collapsed the next time the panel opens.
    if (!target.closest('.menu-list__submenu')) {
      closeAll();
      return;
    }

    // Horizon wraps each link + its grandchildren in a bare <div> inside the
    // column (see snippets/mega-menu-list.liquid). That div is the section.
    const section = target.closest('.mega-menu__column div');
    if (section && section.querySelector(':scope > ul')) section.classList.add(OPEN);

    // Deliberately no `else` — hovering a sibling item (Lighting, Vases…) must NOT
    // close an already-open section. That collapse is the bug.
  });

  // The menu can also be dismissed without the cursor ever crossing the page
  // (Escape, tab away, scroll on a trackpad). Don't leave it stuck open.
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll();
  });
})();
